import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: "root"
})
export class ExporListService {

  baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getExportList(selection: any, model: any): Observable<any> {
    return this.http.post(
        this.baseUrl + `Report/ExportInventory?${selection}`, model, { headers: new HttpHeaders({'Content-Type': 'application/json'}),
        responseType: 'blob' as 'json', observe: 'response' }
    );
  }
}